import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import TextInput from "component/common/TextInput/index";
import { getStatusColor } from "utils/helper";
import { Toast } from "utils/toast";
import arrow from "assets/images/arrow.svg";
import styles from "./styles.module.scss";
import NormalButton from "component/common/NormalButton";
import AddUpi from "../AddUpi";
import SuccessPopUp from "component/common/SuccessPopUp";
import Loader from "../../common/Loader";
import Popup from "component/common/Popup/Popup";
import shield from "assets/images/shield.png";
import { getRoleAction } from "utils/helper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getDisputeById, crateNewPaymentProcess } from "service/Disputed";
import AddDispute from "../AddDispute";

const ViewDisputeDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  let [disputeDetails, setDisputeDetails] = useState({});
  const [confirmPopup, setConfirmPopup] = useState(false);
  let [showModal, setShowModal] = useState(false);
  let [editModal, setEditModal] = useState(false);
  const [isLoader, setLoader] = useState(false);
  const [addupi, setAddUpi] = useState(false);
  const [editUpi, setEditUpi] = useState(false);

  // date picker
  const [startDate, setDate] = useState(new Date());
  const {
    buyerName = "",
    buyerInstaHandle = "",
    note_for_issue = "",
    fundAccountID = [],
    sellerId,
    discount_amount,
    total_amount,
    sellerId_by_user,
    buyerId,
    bankDetails = {},
  } = disputeDetails;

  const [UPICodeDetails, setUPICodeDetails] = useState([]);
  const { isOperationAvailable } = getRoleAction("Dispute");

  useEffect(() => {
    getDisputeDetails();
  }, [id]);

  const makePayment = async (fundId, upiId, account_num) => {
    let findAmount = disputeDetails.total_amount;

    if (findAmount) {
      setLoader(true);
      let body = {
        fundAccountID: fundId,
        discount_amount: total_amount,
        buyerId: buyerId,
        sale_date: startDate,
      };

      account_num ? (body.account_number = account_num) : (body.upi = upiId);
      try {
        let response = await crateNewPaymentProcess(body);
        if (response.status == 200) {
          if (response.data.status === "success") {
            Toast({ type: "success", message: response.data.message });
            setLoader(false);
            showModalPopUp(true);
          }
        }
      } catch (error) {
        Toast({ type: "error", message: error?.data?.message });
      }
    } else {
      Toast({
        type: "error",
        message: "Please Add Amount to make the payment",
      });
    }
  };

  const getDisputeDetails = async () => {
    try {
      let response = await getDisputeById(id);
      if (response.status == 200) {
        setDisputeDetails(response.data.data);
        setUPICodeDetails(response?.data?.data?.UPICode);
      }
    } catch (error) {
      Toast({ type: "error", message: error?.data?.message });
    }
  };

  const showModalFunc = (data, editTrue) => {
    setShowModal(data);
    if (editTrue) {
      setEditModal(true);
    }
  };

  const addUpiFunc = (data, editTrue) => {
    setAddUpi(data);
    if (editTrue) {
      setEditUpi(true);
    }
  };

  const showModalPopUp = () => {
    setConfirmPopup(true);
  };

  // date picker handler
  const selectDateHandler = (d) => {
    setDate(d);
  };

  if (disputeDetails == null) return null;
  if (isLoader) return <Loader />;
  return (
    <>
      <AddDispute
        getDisputed={getDisputeDetails}
        showModal={showModal}
        showModalData={(data) => showModalFunc(data)}
        editModal={editModal}
        viewPage={true}
        id={id}
      />
      <div className={styles.donation_detail}>
        <div className={styles.title}>
          <img
            src={arrow}
            className="back-arrow"
            onClick={() => history.goBack()}
            alt="arrow"
          />
          <b>VIEW DETAILS </b>
        </div>
        <div className={styles.viewPayment_status}>
          <label>
            Payment Status :
            <span
              className={getStatusColor(disputeDetails.productStatus, true)}
              style={{ marginLeft: "10px" }}
            >
              {disputeDetails?.paymentStatus
                ? disputeDetails.paymentStatus?.charAt(0)?.toUpperCase() +
                  disputeDetails.paymentStatus?.substring(
                    1,
                    disputeDetails.paymentStatus?.length
                  )
                : ""}
            </span>
          </label>
        </div>
      </div>
      <div className="row p-5">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4 mb-4">
              <TextInput
                label="Seller ID"
                value={sellerId_by_user}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-4  mb-4">
              <TextInput
                label="Buyer name"
                value={!!buyerName ? buyerName : "---"}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-4  mb-4">
              <TextInput
                label="Buyer Insta Handle"
                value={!!buyerInstaHandle ? buyerInstaHandle : "--"}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-4  mb-4">
              <TextInput
                label="Note for issue"
                value={!!note_for_issue ? note_for_issue : "---"}
                disabled={true}
                color="#000000"
              />
            </div>

            <div className="col-md-4 mb-4">
              <label className={styles.sale_date}>Sale Date</label>
              <DatePicker
                dateFormat="yyyy/MM/dd"
                selected={startDate}
                onChange={selectDateHandler}
                todayButton={"Today"}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-4">
              <TextInput
                label="Discount Amount"
                value={!!discount_amount ? discount_amount : 0}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-4 mb-4">
              <TextInput
                label="Total Amount"
                value={!!total_amount ? total_amount : 0}
                disabled={true}
                color="#000000"
              />
            </div>
          </div>
          <div>
            {bankDetails?.bankName ? (
              <div>
                {fundAccountID?.map(({ account_num, upiId, fundId }) => {
                  return (
                    account_num && (
                      <div>
                        <div className="row">
                          <div className="col-4 mb-4">
                            <TextInput
                              label="Bank Name"
                              value={bankDetails.bankName}
                              disabled={true}
                              color="#000000"
                            />
                          </div>
                          <div className="col-4  mb-4">
                            <TextInput
                              label="Account Number"
                              value={bankDetails.accountNumber}
                              disabled={true}
                              color="#000000"
                            />
                          </div>
                          <div className="col-4  mb-4">
                            <TextInput
                              label="IFSC Code"
                              value={bankDetails.ifscCode}
                              disabled={true}
                              color="#000000"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4  mb-4">
                            <TextInput
                              label="Account Holder Name"
                              value={bankDetails.accountHolderName}
                              disabled={true}
                              color="#000000"
                            />
                          </div>
                          <div className="col-8  mb-4">
                            {isOperationAvailable("Dispute Make Payment") &&
                              disputeDetails.paymentStatus !== "processed" &&
                              disputeDetails.paymentStatus !== "queued" &&
                              disputeDetails.paymentStatus !== "processing" && (
                                <div className="col-md-6 mt-3  mb-4">
                                  <NormalButton
                                    label="MAKE PAYMENT"
                                    onClick={() =>
                                      makePayment(fundId, upiId, account_num)
                                    }
                                    disabled={
                                      disputeDetails.paymentStatus ===
                                        "processing" ||
                                      disputeDetails.paymentStatus ===
                                        "processed"
                                    }
                                  />
                                  <Popup
                                    isOpen={confirmPopup}
                                    setPopup={() => {
                                      setConfirmPopup(false);
                                      history.push(`/admin/dispute/list`);
                                    }}
                                    close={false}
                                  >
                                    <div>
                                      <div>
                                        <h4 className={styles.addPopup}>
                                          Make Payment
                                        </h4>
                                        <div className={styles.blank} />
                                      </div>
                                      <div className={styles.shield}>
                                        <img src={shield} alt="success" />
                                      </div>
                                      <div>
                                        <label className={styles.content}>
                                          Payment Initiated{" "}
                                        </label>
                                      </div>
                                      <div>
                                        <label className={styles.content}>
                                          Successfully{" "}
                                        </label>
                                      </div>
                                      <div className={styles.btnFooter}>
                                        <NormalButton
                                          label="Continue"
                                          onClick={() =>
                                            history.push(`/admin/dispute/list`)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </Popup>
                                  <SuccessPopUp />
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            ) : (
              <div>
                {fundAccountID?.map(({ upiId, fundId }) => {
                  return (
                    fundId && (
                      <div className="col-md-12 row">
                        <div className="col-md-3  mb-4">
                          <TextInput
                            label="Seller UPI ID"
                            value={upiId}
                            disabled={true}
                            color="#000000"
                          />
                        </div>
                        {isOperationAvailable("Dispute Make Payment") &&
                          disputeDetails.paymentStatus !== "processed" &&
                          disputeDetails.paymentStatus !== "queued" &&
                          disputeDetails.paymentStatus !== "processing" && (
                            <div className="col-md-6 mt-3  mb-4">
                              <NormalButton
                                label="MAKE PAYMENT"
                                onClick={() => makePayment(fundId, upiId)}
                                disabled={
                                  disputeDetails.paymentStatus ===
                                    "processing" ||
                                  disputeDetails.paymentStatus === "processed"
                                }
                              />
                              <Popup
                                isOpen={confirmPopup}
                                setPopup={() => {
                                  setConfirmPopup(false);
                                  history.push(`/admin/dispute/list`);
                                }}
                                close={false}
                              >
                                <div>
                                  <div>
                                    <h4 className={styles.addPopup}>
                                      Make Payment
                                    </h4>
                                    <div className={styles.blank} />
                                  </div>
                                  <div className={styles.shield}>
                                    <img src={shield} alt="success" />
                                  </div>
                                  <div>
                                    <label className={styles.content}>
                                      Payment Initiated{" "}
                                    </label>
                                  </div>
                                  <div>
                                    <label className={styles.content}>
                                      Successfully{" "}
                                    </label>
                                  </div>
                                  <div className={styles.btnFooter}>
                                    <NormalButton
                                      label="Continue"
                                      onClick={() =>
                                        history.push(`/admin/dispute/list`)
                                      }
                                    />
                                  </div>
                                </div>
                              </Popup>
                              <SuccessPopUp />
                            </div>
                          )}
                      </div>
                    )
                  );
                })}
              </div>
            )}
          </div>

          {bankDetails.bankName ? (
            ""
          ) : (
            <div>
              {isOperationAvailable("AddUpi") &&
                disputeDetails.paymentStatus !== "processed" &&
                disputeDetails.paymentStatus !== "queued" &&
                disputeDetails.paymentStatus !== "processing" && (
                  <AddUpi
                    getSellerListData={getDisputeDetails}
                    addupi={addupi}
                    showModalData={(data) => addUpiFunc(data)}
                    editUpi={editUpi}
                    viewPage={false}
                    id={id}
                    setEditModal={setEditUpi}
                    sellerId_by_user={sellerId_by_user}
                    sellerIds={sellerId}
                    UPICodeDetails={UPICodeDetails}
                  />
                )}
            </div>
          )}
        </div>
      </div>

      {/* <div className="row">
        <div className={`${styles.footer_btn} + col-md-12 mt-3  mb-4`}>
          <NormalButton
            label="EDIT"
            onClick={() => showModalFunc(true, "editModal")}
            disabled={disputeDetails.paymentStatus === "processed"}
          />
        </div>
      </div> */}
    </>
  );
};

export default ViewDisputeDetails;
